module.exports = __webpack_public_path__ + "static/media/official-venue.b2af000d.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/official-venue.png
// module id = 683
// module chunks = 6